import { render, staticRenderFns } from "./MandateAlert.vue?vue&type=template&id=5b3afb75"
import script from "./MandateAlert.vue?vue&type=script&lang=js"
export * from "./MandateAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports